import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core'

import { DefaultLayoutComponent } from '../default-layout'
import { AuthService } from '../../services/auth.service'
import { MenuItem } from '../../../models/menu-item.model'

@Component({
    selector: 'ui-menu',
    templateUrl: './menu.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent implements OnInit {
    @Input()
    menuItems: MenuItem[]
    constructor(private viewport: DefaultLayoutComponent, private auth: AuthService) {}

    ngOnInit() {
        this.menuItems = this.filterMenuItems(this.menuItems)
    }

    filterMenuItems(menuItems: MenuItem[]): MenuItem[] {
        return this.menuItems
            .filter(item => this.auth.hasRoleAssigned(item.roles))
            .map(item => (!item.children ? item : { ...item, children: this.filterMenuItems(item.children) }))
    }

    onAction(event: Event) {
        this.viewport.onMenuClick(event)
    }
}
